var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaseyShort = function SvgCaseyShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 129 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 65.87v60.999h78v-61l21-23.5-23.5-12-13 19H41l-13-19-23.5 12 21 23.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.644 87.206c1.736 0 3.144-1.419 3.144-3.169s-1.408-3.168-3.144-3.168c-1.736 0-3.144 1.419-3.144 3.168 0 1.75 1.407 3.169 3.144 3.169ZM80.644 87.206c1.736 0 3.143-1.419 3.143-3.169s-1.407-3.168-3.143-3.168c-1.737 0-3.144 1.419-3.144 3.168 0 1.75 1.407 3.169 3.144 3.169Z",
    fill: "#363840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.338 27.626a2.5 2.5 0 0 1 3.063.69l13.523 17.053h43.152l13.523-17.053a2.5 2.5 0 0 1 3.063-.69L127.604 39.9a2.5 2.5 0 0 1 .666 4.009L106 66.23v60.639a2.5 2.5 0 0 1-2.5 2.5h-78a2.5 2.5 0 0 1-2.5-2.5v-60.64L.73 43.909a2.5 2.5 0 0 1 .666-4.01l24.942-12.272ZM28 67.37v57h73v-57H28Zm75.874-6.088 18.393-18.436-20.003-9.842-11.46 14.45 13.07 13.828Zm-6.24 1.088-11.525-12H42.891l-11.524 12h66.266ZM38.195 47.453l-11.46-14.45-20.003 9.842 18.393 18.436 13.07-13.828Z",
    fill: "#363840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 92.367v2.501c0 4.447-1.748 8.14-4.66 10.693-2.876 2.521-6.74 3.807-10.84 3.807-9.296 0-15.5-6.409-15.5-14.5v-2.5h15.5a109702.818 109702.818 0 0 1 12.999 0H80Zm-25.687 5.001c1.035 3.991 4.602 7 10.187 7 3.08 0 5.716-.964 7.544-2.567 1.267-1.11 2.218-2.586 2.668-4.432H54.313Z",
    fill: "#363840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#363840",
    d: "m117.845 5.654 3.468 5.901-11.802 6.937-3.468-5.901zM49.237 43.543l6.498-2.152 4.304 12.995-6.497 2.153z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.accentFill,
    d: "m20.595 18.098-1.193 5.165-10.33-2.387 1.193-5.165zM44.523 36.755 43.33 41.92 33 39.534l1.193-5.165zM68.618 7.184l4.862 4.818-9.637 9.724-4.862-4.819zM77.637 45.37l4.862 4.818-9.637 9.723L68 55.093z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m29.321 6.404 10.29-4.925 6.764 22.059-4.116 1.97L29.32 6.404ZM88.6 1.479 99.067 6.02 86.843 25.59l-4.187-1.817 5.945-22.293Z",
    fill: "#363840"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 3,
    r: 3,
    fill: "#00935E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 34.369,
    r: 3,
    fill: "#363840"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 27,
    r: 3,
    fill: props.accentFill
  }));
};
export default SvgCaseyShort;